import React, { useState } from "react";
import { Slider } from "./Slider.js";
import { Button } from "../components/Button.js";
export const SliderButton = ({ filloutId, domain, inheritParameters, parameters, sliderDirection, onInit, onPageChange, onSubmit, text, color, size, float, }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: () => setIsOpen(true), text: text, color: color, size: size, float: float }),
        isOpen && (React.createElement(Slider, { filloutId: filloutId, domain: domain, inheritParameters: inheritParameters, parameters: parameters, sliderDirection: sliderDirection, onClose: () => setIsOpen(false), onInit: onInit, onPageChange: onPageChange, onSubmit: onSubmit }))));
};
